module.exports = "/_next/static/images/5da488df741738677a5acfb734b26973-complexity@md-2x.jpg.webp";